import { get } from '@kit/utils/APIV1.js'
import { randomAlphaNumString } from '@kit/utils/Formats'

export const gtfsMap = async() => {
  return get('/gtfs-map/id/162')
}

export const stops = async(routeID) => {
  const r = await get('/stops/route_id/'+routeID)
  return r
}

export const route = async(routeID) => {
  const r = await get('/route/route_id/'+routeID)
  return r
}

export const htaRoute = async(routeID) => {
  const r = await get('/hta-route/route_id/'+routeID)
  return r
}

export const gtfsrtVehicles = async(url) => {
  const response = await fetch(`/gtfs-rt-vehicles?v=${randomAlphaNumString(6)}`)
  const responseData = await response.json()
  return responseData
}


export const routes = async() => {
  const r = await get('/routes')
  return r
}

export const htaRoutes = async() => {
  const r = await get('hta-routes')
  return r
}

export const gtfsrtTripUpdates = async() => {
  const response = await fetch(`/gtfs-rt-trip-updates?v=${randomAlphaNumString(6)}`)
  const responseData = await response.json()
  return responseData
}

export const gtfsrtAlerts = async() => {
  const response = await fetch(`/gtfs-rt-alerts?v=${randomAlphaNumString(6)}`)
  const responseData = await response.json()
  return responseData

/*
  return { "header": {
    "gtfsRealtimeVersion": "2.0",
    "incrementality": "FULL_DATASET",
    "timestamp": "1782845697"
  },
  "entity": [
    {
      "id": "2dd4dfe2-29d9-4bce-bb08-296da9040e94",
      "alert": {
        "activePeriod": [
          {
            "start": "1782889200",
            "end": "1782972000"
          }
        ],
        "informedEntity": [
          {
            "routeId": "RTS",
            "stopId": "1286"
          }
        ],
        "cause": "CONSTRUCTION",
        "effect": "DETOUR",
        "headerText": {
          "translation": [
            {
              "text": "Detour on Route RTS"
            }
          ]
        },
        "descriptionText": {
          "translation": [
            {
              "text": "Buses on Route RTS will be on detour due to construction. Detour in effect starting July 1 at 12:00 AM. Detour ends July 1 at approximately 11:00 PM.\n\nToward 15 North - Trinidad, stop G St & 5th St will not be served."
            }
          ]
        }
      }
    },
    {
      "id": "238b22bc-4ece-41e5-b365-fc8e212ffb75",
      "alert": {
        "activePeriod": [
          {
            "start": "1782889200",
            "end": "1787813940"
          }
        ],
        "informedEntity": [
          {
            "routeId": "RTS",
            "stopId": "1286"
          }
        ],
        "cause": "CONSTRUCTION",
        "effect": "DETOUR",
        "headerText": {
          "translation": [
            {
              "text": "Detour on Route RTS"
            }
          ]
        },
        "descriptionText": {
          "translation": [
            {
              "text": "Buses on Route RTS will be on detour due to construction. Detour in effect starting July 1 at 12:00 AM. Detour ends August 26 at approximately 11:59 PM.\n\nToward 15 North - Trinidad, stop G St & 5th St will not be served.\n\nAlternate stops are available."
            }
          ]
        }
      }
    },
    {
      "id": "ef7ae61b-ce5c-4a15-8a18-8d997e49f9e6",
      "alert": {
        "activePeriod": [
          {
            "start": "1782212400",
            "end": "1782885600"
          }
        ],
        "informedEntity": [
          {
            "routeId": "RTS",
            "stopId": "1897"
          },
          {
            "routeId": "RTS",
            "stopId": "1281"
          }
        ],
        "cause": "CONSTRUCTION",
        "effect": "DETOUR",
        "headerText": {
          "translation": [
            {
              "text": "Detour on Route RTS"
            }
          ]
        },
        "descriptionText": {
          "translation": [
            {
              "text": "Buses on Route RTS will be on detour due to construction. Detour in effect starting June 23 at 4:00 AM. Detour ends June 30 at approximately 11:00 PM.\n\nToward 15 North - Trinidad, stops Westhaven Offramp & Westhaven Dr and 6th Ave & Spring Ln - NB Stop (Westhaven Fire Dept) will not be served."
            }
          ]
        }
      }
    },
    {
      "id": "806062bd-beea-49e5-8e8f-d4776822271c",
      "alert": {
        "activePeriod": [
          {
            "start": "1782212400",
            "end": "1782889140"
          }
        ],
        "informedEntity": [
          {
            "routeId": "RTS",
            "stopId": "4001"
          },
          {
            "routeId": "RTS",
            "stopId": "1898"
          }
        ],
        "cause": "CONSTRUCTION",
        "effect": "DETOUR",
        "headerText": {
          "translation": [
            {
              "text": "Detour on Route RTS"
            }
          ]
        },
        "descriptionText": {
          "translation": [
            {
              "text": "Buses on Route RTS will be on detour due to construction. Detour in effect starting June 23 at 4:00 AM. Detour ends June 30 at approximately 11:59 PM.\n\nToward 2 South - Scotia, stops 6th Ave & Spring Ln - SB Stop (Westhaven Fire Dept) and Scenic Dr & Moonstone Beach Rd will not be served."
            }
          ]
        }
      }
    },
    {
      "id": "398e5129-b99e-431a-a484-624d1afb9a11",
      "alert": {
        "activePeriod": [
          {
            "start": "1781532000",
            "end": "1786755600"
          }
        ],
        "informedEntity": [
          {
            "routeId": "E Grn",
            "stopId": "1317"
          },
          {
            "routeId": "E Grn",
            "stopId": "1320"
          },
          {
            "routeId": "E Grn",
            "stopId": "1356"
          }
        ],
        "cause": "CONSTRUCTION",
        "effect": "DETOUR",
        "headerText": {
          "translation": [
            {
              "text": "Detour on Route E Grn"
            }
          ]
        },
        "descriptionText": {
          "translation": [
            {
              "text": "Buses on Route E Grn will be on detour due to construction. Detour in effect weekdays from 7:00 AM to 6:00 PM, starting June 15. Detour ends August 14 at approximately 6:00 PM.\n\nToward Eureka Green Loop, stops from Myrtle Ave & Hubbard Ln (Myrtle Ave. Market) through Harris St (Redwood Acres) will not be served."
            }
          ]
        }
      }
    }
  ]
}
*/
    
}


export const agencies = async() => {
  const response = await fetch('/agencies')
  const responseData = await response.json()
  return responseData  
}